export default class extends Controller {
  connect(){
    $(this.element).delay(3000).fadeOut(1600);
  }
}
